import React, { useEffect, useRef, useState } from "react";
import "./styleAddPlans.css";

import { setIsAddPlan, setPlatformList } from "../../../features/platforms/platformsSlice";
import { useDispatch, useSelector } from "react-redux";
import { postPlan, updatePlan } from "../../../services/planServices";
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import ImageTool from "@editorjs/image"
import { toast } from "react-toastify";
import { setPlanList } from "../../../features/plans/planSlice";
import { useNavigate } from "react-router";

function INCSUBAddPlans(param) {
    const dispatch = useDispatch();
    const editorInstanceRef = useRef(null);
    const platformInfo = useSelector((state) => state.platforms.platformInfo);
    const planList = useSelector((state) => state.plans.planList);
    const platformList = useSelector((state) => state.platforms.platformList);
    const [pNameCount, setPNameCount] = useState(0); // State for plan name character count
    const [plan, setPlan] = useState({
        planName: "",
        planAmount: "",
        allowedMembers: '',
        planDuration: '',
        planDescription: "",
        planTermsCondition: "",
        visible: null,
        encryptedPlatformId: platformInfo.platformId
    });
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);

    useEffect(() => {
        if (param.plan) {
            setPlan(param.plan);
        }

        if (editorInstanceRef.current) {
            editorInstanceRef.current.destroy();
            editorInstanceRef.current = null;
        }

        try {
            editorInstanceRef.current = new EditorJS({
                holder: "editorjs",
                tools: {
                    header: Header,
                    list: List,
                    image: {
                        class: ImageTool,
                        config: {
                            endpoints: {
                                byFile: "http://localhost:3000/uploadFile",
                                byUrl: "http://localhost:3000/fetchUrl",
                            },
                        },
                    },
                },
                placeholder: "Start typing here...",
                data: param.plan?.planDescription
                    ? JSON.parse(param.plan.planDescription)
                    : null,
                onChange: async () => {
                    if (editorInstanceRef.current) {
                        const content = await editorInstanceRef.current.save();
                        changeEditorJs(content);
                    }
                },
            });
        } catch (error) {
            console.error("Error initializing Editor.js:", error);
        }

        return () => {
            if (editorInstanceRef.current) {
                editorInstanceRef.current.destroy();
                editorInstanceRef.current = null;
            }
        };
    }, [param]);

    const changeEditorJs = async (e) => {
        if (editorInstanceRef.current) {
            try {
                const savedData = await editorInstanceRef.current.save();
                setPlan((prev) => ({
                    ...prev,
                    planDescription: JSON.stringify(savedData),
                }));
                if (savedData.blocks.length < 1) {
                    setPlan((prev) => ({
                        ...prev,
                        planDescription: '',
                    }));
                }
            } catch (error) {
                console.error('Error saving content:', error);
            }
        }
    };

    useEffect(() => {
        if (!param && !param.plan) {
            setPlan(param.plan)
        }
    }, [param])
    const handlePlanNameChange = (e) => {
        if (e.target.value.length > 12) {
            return
        }
        setPNameCount(e.target.value.length);
        setPlan((prev => ({
            ...prev,
            planName: e.target.value
        })))

    }
    const handleplanAmountChange = (e) => {
        const value = e.target.value;
        const validNumberRegex = /^(?:\d+|\d*\.\d+)?$/;

        if (value === '' || validNumberRegex.test(value)) {
            setPlan(prev => ({
                ...prev,
                planAmount: value === '' ? '' : parseFloat(value)
            }));
        }
    };


    const handleallowedMembersChnage = (e) => {
        const regex = /^[0-9]*$/
        if (regex.test(e.target.value)) {
            setPlan((prev => ({
                ...prev,
                allowedMembers: parseInt(e.target.value)
            })))
        }
        if (e.target.value === '') {
            setPlan((prev => ({
                ...prev,
                allowedMembers: e.target.value
            })))
        }
    }
    const handlePlanDuration = (e) => {
        const regex = /^[0-9]*$/
        if (regex.test(e.target.value)) {
            setPlan((prev => ({
                ...prev,
                planDuration: parseInt(e.target.value)
            })))
        }
        if (e.target.value === '') {
            setPlan((prev => ({
                ...prev,
                planDuration: ''
            })))
        }

    }
    const handleTermsandConditions = (e) => {
        setPlan((prev => ({
            ...prev,
            planTermsCondition: e.target.value
        })))
    }
    const [error, setError] = useState(false)


    const findUpdatedFields = (original, updated) => {
        let updatedData = {};

        Object.keys(original).forEach(key => {
            if (original[key] !== updated[key]) {
                updatedData[key] = updated[key];
            }
            if (Object.keys(updatedData).length > 0) {
                updatedData.platformPlanId = original.platformPlanId;
            }

        });

        return Object.keys(updatedData).length > 0 ? updatedData : false;
    };


    const handleChangePlanData = async (e) => {
        const isInvalid = [
            plan.planName,
            plan.planAmount,
            plan.planDescription,
            plan.planTermsCondition,
            plan.allowedMembers,
            plan.planDuration
        ].some(field => field === '' || field === null || field === undefined);

        if (isInvalid) {
            setError(true)
            return;
        }
        setPlan({...plan,
            planName:plan.planName.trim()
        })
        if (!param.plan) {
            try {
                const addPlan = await postPlan(plan)
                if (addPlan.status === 201) {
                    const updatedPlanList = [
                        ...(planList ?? []),
                        {
                            ...plan,
                            platformPlanId: addPlan.data.data.idValue,
                        }
                    ];
                    const updatePlatformList = platformList.platformList.map((platfrom) => platfrom.platformId !== platformInfo.platformId ? platfrom : {
                        ...platfrom,
                        planCount: updatedPlanList.length
                    })
                    dispatch(setPlatformList({
                        ...platformList,
                        platformList: updatePlatformList
                    }))
                    dispatch(setPlanList(updatedPlanList));
                    dispatch(setIsAddPlan(false))
                }
                else if (addPlan.status === 401) {
                    window.localStorage.setItem('userData', null)
                    navigate('/login');
                } else if (![401, 201].includes(addPlan.status)) {
                    toast.error(addPlan.data.message)
                }
            } catch (err) {
                toast.error("something went wrong")
            }


        } else {
            try {
                const updatedData = findUpdatedFields(param.plan, plan);
                if (!updatedData) {
                    toast.warning('No change in previous message')
                    return
                }

                const updatePlanData = await updatePlan(updatedData)
                if (updatePlanData?.status === 200) {
                    const updatedList = planList.map(plans =>
                        plans.platformPlanId === plan.platformPlanId
                            ? { ...plans, ...plan }
                            : plans
                    );

                    dispatch(setPlanList(updatedList));
                } else if (updatePlanData.status === 301) {
                    toast.error("Network Error");
                } else if (updatePlanData.status === 500) {
                    toast.error("Internal server error");
                } if (updatePlanData?.status === 401) {
                    window.localStorage.setItem('token', null)
                    navigate('/login')
                    return
                }
                if ([409, 400, 403].includes(updatePlanData?.status)) {
                    toast.error(updatePlanData?.data.message);
                }
                // setLoader(false)
                dispatch(setIsAddPlan(false))

            } catch (err) {
                toast.error("something went wrong")
            }
        }
    }


    return (
        <div className="INCSUBAddPlans">
            <div className="INCSUBAddPlans_container">
                <div className="INCSUBAddPlans_feilds_container">
                    <svg className="cancel_btn" onClick={() => dispatch(setIsAddPlan(false))} width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.46416 1.47683C1.77145 1.16963 2.18818 0.997049 2.6227 0.997049C3.05721 0.997049 3.47394 1.16963 3.78124 1.47683L9.99672 7.69231L16.2122 1.47683C16.3634 1.32032 16.5442 1.19548 16.7441 1.1096C16.944 1.02372 17.1591 0.978515 17.3766 0.976624C17.5942 0.974734 17.81 1.01619 18.0114 1.09859C18.2128 1.18098 18.3957 1.30266 18.5496 1.45652C18.7035 1.61038 18.8251 1.79334 18.9075 1.99473C18.9899 2.19611 19.0314 2.41189 19.0295 2.62947C19.0276 2.84706 18.9824 3.06208 18.8965 3.26201C18.8106 3.46193 18.6858 3.64275 18.5293 3.79391L12.3138 10.0094L18.5293 16.2249C18.8278 16.5339 18.9929 16.9479 18.9892 17.3775C18.9855 17.8072 18.8131 18.2182 18.5093 18.522C18.2055 18.8258 17.7945 18.9982 17.3648 19.0019C16.9352 19.0056 16.5213 18.8405 16.2122 18.542L9.99672 12.3265L3.78124 18.542C3.47218 18.8405 3.05825 19.0056 2.62859 19.0019C2.19894 18.9982 1.78794 18.8258 1.48412 18.522C1.18029 18.2182 1.00796 17.8072 1.00422 17.3775C1.00049 16.9479 1.16566 16.5339 1.46416 16.2249L7.67964 10.0094L1.46416 3.79391C1.15695 3.48661 0.984375 3.06989 0.984375 2.63537C0.984375 2.20085 1.15695 1.78413 1.46416 1.47683Z" fill="black" />
                    </svg>
                    <div className="INCSUBAddPlans_heading">Add plans</div>
                    <div className="INCSUBAddPlans_form_container">
                        <form>
                            <div className="INCSUBAddPlans_form_fullfeild_container">
                                <label>Plan Name <div>{pNameCount}/12</div></label>
                                <input value={plan.planName} onChange={handlePlanNameChange} placeholder="Enter name" style={{ border: error && plan.planName === '' ? '1px solid red' : null }} />
                            </div>
                            <div className="INCSUBAddPlans_form_halffeild_container">
                                <div className="INCSUBAddPlans_form_fullfeild_container half">
                                    <label>Plan Price</label>
                                    <input type="number" value={plan.planAmount} onChange={handleplanAmountChange} placeholder="₹Enter amount " style={{ border: error && plan.planAmount === '' ? '1px solid red' : null }} />
                                </div>

                            </div>
                            <div className="INCSUBAddPlans_form_halffeild_container">
                                <div className="INCSUBAddPlans_form_fullfeild_container half">
                                    <label>Duration (in Days)</label>
                                    <input value={plan.planDuration} onChange={handlePlanDuration} placeholder="Duration" style={{ border: error && plan.planDuration === '' ? '1px solid red' : null }} />
                                </div>
                                <div className="INCSUBAddPlans_form_fullfeild_container half">
                                    <label>No. of members</label>
                                    <input type="number" value={plan.allowedMembers} onChange={handleallowedMembersChnage} placeholder="00" style={{ border: error && plan.allowedMembers === '' ? '1px solid red' : null }} />
                                </div>
                            </div>

                            <div className="INCSUBAddPlans_form_fullfeild_container">
                                <label>Details</label>
                                <div
                                    id="editorjs"
                                    style={{
                                        padding: "16px",
                                        borderRadius: "5px",
                                        textAlign: "left",
                                        border: error && plan.planDescription === '' ? '1px solid red' : null
                                    }}
                                />
                            </div>
                            <div className="INCSUBAddPlans_form_fullfeild_container">
                                <label>
                                    Terms & Conditions <span>(1-2 lines)</span>
                                </label>
                                <textarea value={plan.planTermsCondition} onChange={handleTermsandConditions} placeholder="Type here...." style={{ border: error && plan.planTermsCondition === '' ? '1px solid red' : null }}></textarea>
                            </div>
                            <div className="INCSUBAddPlans_form_fullfeild_container">
                                <div className='INCSUBusrupdate_btn submit' onClick={handleChangePlanData}>Add</div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default INCSUBAddPlans;
